import { STATUS_REQUERIMENTO, ID_RELATORIO } from 'utils/consts';
import { getArrayStatusFormatted } from 'utils/funcaoPadrao';
import { getNomeMes } from 'utils/dateFormatter';
import moment from 'moment/moment';

const _ordenarMeses = mesesAno => {
  return mesesAno.meses.sort(function (a, b) {
    return a.mesReferencia - b.mesReferencia;
  });
};

const _formatterDate = data => {
  return moment(data).format('DD/MM/YYYY');
};

const _formatterTitle = (filtroSelecionado, todosAssuntos) => {
  const dataInicio = _formatterDate(filtroSelecionado.DataInicio);
  const dataFim = _formatterDate(filtroSelecionado.DataFim);
  let title = `Período ${dataInicio} - ${dataFim}`;

  if (filtroSelecionado?.AssuntoId > 0) {
    const descricaoAssunto = todosAssuntos?.find(x => x.id === filtroSelecionado.AssuntoId)?.descricao;

    title += ` | ${descricaoAssunto}`;
  }

  return title;
};

const _formatterGraficoBarras = (
  title,
  label,
  valoresAberto,
  valoresFechados,
  valoresPendentes,
  isSetorial = false
) => {
  const datasets = [
    {
      label: 'Fechados',
      data: valoresFechados,
      backgroundColor: STATUS_REQUERIMENTO.CANCELADO?.cor,
      borderColor: STATUS_REQUERIMENTO.CANCELADO?.borderColor,
      borderWidth: 1,
    },
    {
      label: 'Pendente (Em Análise - Em Atendimento - Encaminhados - Direcionados)',
      data: valoresPendentes,
      backgroundColor: STATUS_REQUERIMENTO.EM_ATENDIMENTO?.cor,
      borderColor: STATUS_REQUERIMENTO.EM_ATENDIMENTO?.borderColor,
      borderWidth: 1,
    },
  ];

  if (!isSetorial)
    datasets.unshift({
      label: 'Abertos',
      data: valoresAberto,
      backgroundColor: STATUS_REQUERIMENTO.ABERTO?.cor,
      borderColor: STATUS_REQUERIMENTO.ABERTO?.borderColor,
      borderWidth: 1,
    });

  return {
    title: title,
    labels: label,
    datasets,
  };
};

const _montarFatiaPizza = dados => {
  const array = [];

  Object.keys(dados).forEach(key => {
    const fatiaPizzaFormatada = getArrayStatusFormatted().find(x => x.identificador === key);
    fatiaPizzaFormatada.valor = dados[key];
    fatiaPizzaFormatada.porcentagem = dados[key].toFixed(2);
    array.push(fatiaPizzaFormatada);
  });

  const valorSomaTotal = array.reduce((a, b) => a + b.valor, 0);

  if (valorSomaTotal === 0) {
    return [
      {
        id: 0,
        valor: 0,
        porcentagem: 100,
        descricao: 'Sem valor',
        cor: '#f5f5f5',
        borderColor: '#bfbfbf',
      },
    ];
  }
  return array;
};

export const montarGraficoRelatorioResumidoTipo = (dadosGrafico, filtroSelecionado, todosAssuntos, isSetorial) => {
  return dadosGrafico?.periodo?.map(dadosAnos => {
    let label = [];

    const title = _formatterTitle(filtroSelecionado, todosAssuntos);
    const valoresAberto = [];
    const valoresFechados = [];
    const valoresPendentes = [];

    dadosAnos.meses = dadosAnos?.meses?.length > 0 ? _ordenarMeses(dadosAnos) : dadosAnos.meses;

    dadosAnos?.meses.forEach(function (dadosMensal) {
      label.push(getNomeMes(dadosMensal?.mesReferencia, dadosAnos?.anoReferencia));
      valoresAberto.push(dadosMensal?.relatorioSolicitacoesResumido[ID_RELATORIO.ABERTO]);
      valoresFechados.push(dadosMensal?.relatorioSolicitacoesResumido[ID_RELATORIO.FECHADO]);
      valoresPendentes.push(dadosMensal?.relatorioSolicitacoesResumido[ID_RELATORIO.PENDENTE]);
    });

    label = [...new Set(label)];

    return _formatterGraficoBarras(title, label, valoresAberto, valoresFechados, valoresPendentes, isSetorial);
  });
};

export const montarGraficoRelatorioResumidoSolicitacao = (dadosGrafico, filtroSelecionado, isSetorial) => {
  return dadosGrafico?.periodo?.map(dadosAnos => {
    const title = _formatterTitle(filtroSelecionado);
    let label = [];
    let valoresAberto = [];
    let valoresFechados = [];
    let valoresPendentes = [];

    dadosAnos.meses = dadosAnos?.meses?.length > 0 ? _ordenarMeses(dadosAnos) : dadosAnos.meses;

    dadosAnos?.meses.forEach(dadosMensal => {
      label.push(getNomeMes(dadosMensal?.mesReferencia, dadosAnos?.anoReferencia));
      valoresAberto = [...valoresAberto, dadosMensal?.relatorioSolicitacoesResumido[ID_RELATORIO.ABERTO]];
      valoresFechados = [...valoresFechados, dadosMensal?.relatorioSolicitacoesResumido[ID_RELATORIO.FECHADO]];
      valoresPendentes = [...valoresPendentes, dadosMensal?.relatorioSolicitacoesResumido[ID_RELATORIO.PENDENTE]];

      return null;
    });

    label = [...new Set(label)];

    return _formatterGraficoBarras(title, label, valoresAberto, valoresFechados, valoresPendentes, isSetorial);
  });
};

export const montarGraficoPizzaStatus = dadosPeriodo => {
  const valores = [];
  const label = [];
  const cor = [];
  const borderColor = [];
  _montarFatiaPizza(dadosPeriodo.totalizadorRelatorioStatus).forEach(item => {
    valores.push(item.porcentagem);
    label.push(item?.descricao);
    cor.push(item?.cor);
    borderColor.push(item?.borderColor);
  });

  return {
    labels: label,
    datasets: [
      {
        label: '',
        hidden: false,
        data: valores,
        backgroundColor: cor,
        borderColor: borderColor,
        borderWidth: 1,
      },
    ],
  };
};

export const montarGraficoPerformanceGeralResumido = (dadosGrafico, filtroSelecionado) => {
  return dadosGrafico?.periodo?.map(dadosPeriodo => {
    const title = _formatterTitle(filtroSelecionado);
    const iniciados = dadosPeriodo?.atendentes.reduce((a, b) => a + b?.[ID_RELATORIO.PERFORMANCE_INICIADOS], 0);
    const fechados = dadosPeriodo?.atendentes.reduce((a, b) => a + b?.[ID_RELATORIO.PERFORMANCE_FECHADO], 0);
    const pendentes = dadosPeriodo?.atendentes.reduce((a, b) => a + b?.[ID_RELATORIO.PERFORMANCE_PENDENTES], 0);
    const encaminhado = dadosPeriodo?.atendentes.reduce((a, b) => a + b?.[ID_RELATORIO.PERFORMANCE_ENCAMINHADO], 0);
    const devolvido = dadosPeriodo?.atendentes.reduce((a, b) => a + b?.[ID_RELATORIO.PERFORMANCE_DEVOLVIDO], 0);

    return {
      title: title,
      labels: ['Geral'],
      datasets: [
        {
          label: 'Iniciados',
          data: [iniciados],
          backgroundColor: STATUS_REQUERIMENTO.ABERTO?.cor,
          borderColor: STATUS_REQUERIMENTO.ABERTO?.borderColor,
          borderWidth: 1,
        },
        {
          label: 'Fechados',
          data: [fechados],
          backgroundColor: STATUS_REQUERIMENTO.FINALIZADO_DEFERIDO?.cor,
          borderColor: STATUS_REQUERIMENTO.FINALIZADO_DEFERIDO?.borderColor,
          borderWidth: 1,
        },
        {
          label: 'Pendente',
          data: [pendentes],
          backgroundColor: STATUS_REQUERIMENTO.EM_ATENDIMENTO?.cor,
          borderColor: STATUS_REQUERIMENTO.EM_ATENDIMENTO?.borderColor,
          borderWidth: 1,
        },
        {
          label: 'Encaminhado',
          data: [encaminhado],
          backgroundColor: STATUS_REQUERIMENTO.ENCAMINHADO_ATENDENTE?.cor,
          borderColor: STATUS_REQUERIMENTO.ENCAMINHADO_ATENDENTE?.borderColor,
          borderWidth: 1,
        },
        {
          label: 'Devolvido',
          data: [devolvido],
          backgroundColor: STATUS_REQUERIMENTO.DEVOLVIDO_CONTRIBUINTE?.cor,
          borderColor: STATUS_REQUERIMENTO.DEVOLVIDO_CONTRIBUINTE?.borderColor,
          borderWidth: 1,
        },
      ],
    };
  });
};

export const montarGraficoPerformanceAtendenteResumido = (dadosGrafico, filtroSelecionado, isSetorial) => {
  return dadosGrafico?.periodo?.map(dadosPeriodo => {
    let label = [];

    const valoresIniciados = [];
    const valoresFechados = [];
    const valoresPendentes = [];
    const valoresEncaminhado = [];
    const valoresDevolvido = [];

    let title = _formatterTitle(filtroSelecionado);
    if (dadosPeriodo?.atendentes.length === 1) title += ` - ${dadosPeriodo.atendentes[0].nomeAtendente}`;

    dadosPeriodo?.atendentes.forEach(atendente => {
      label.push(atendente?.nomeAtendente);
      valoresIniciados.push(atendente?.[ID_RELATORIO.PERFORMANCE_INICIADOS]);
      valoresFechados.push(atendente?.[ID_RELATORIO.PERFORMANCE_FECHADO]);
      valoresPendentes.push(atendente?.[ID_RELATORIO.PERFORMANCE_PENDENTES]);
      valoresEncaminhado.push(atendente?.[ID_RELATORIO.PERFORMANCE_ENCAMINHADO]);
      valoresDevolvido.push(atendente?.[ID_RELATORIO.PERFORMANCE_DEVOLVIDO]);

      return null;
    });

    return {
      title: title,
      labels: label,
      datasets: [
        {
          label: 'Iniciados',
          data: valoresIniciados,
          backgroundColor: STATUS_REQUERIMENTO.ABERTO.cor,
          borderColor: STATUS_REQUERIMENTO.ABERTO?.borderColor,
          borderWidth: 1,
        },
        {
          label: 'Fechados',
          data: valoresFechados,
          backgroundColor: STATUS_REQUERIMENTO.CANCELADO?.cor,
          borderColor: STATUS_REQUERIMENTO.CANCELADO?.borderColor,
          borderWidth: 1,
        },
        {
          label: `Pendente (Em Análise - Em Atendimento ${isSetorial ? '- Direcionado ' : ''})`,
          data: valoresPendentes,
          backgroundColor: STATUS_REQUERIMENTO.EM_ATENDIMENTO?.cor,
          borderColor: STATUS_REQUERIMENTO.EM_ATENDIMENTO?.borderColor,
          borderWidth: 1,
        },
        {
          label: 'Encaminhado',
          data: valoresEncaminhado,
          backgroundColor: STATUS_REQUERIMENTO.ENCAMINHADO_ATENDENTE?.cor,
          borderColor: STATUS_REQUERIMENTO.ENCAMINHADO_ATENDENTE?.borderColor,
          borderWidth: 1,
        },
        {
          label: 'Devolvido',
          data: valoresDevolvido,
          backgroundColor: STATUS_REQUERIMENTO.DEVOLVIDO_CONTRIBUINTE?.cor,
          borderColor: STATUS_REQUERIMENTO.DEVOLVIDO_CONTRIBUINTE?.borderColor,
          borderWidth: 1,
        },
      ],
    };
  });
};
